import 'slick-carousel';

$('.js-slider .slider__slides').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	dots: true,
	arrows: false,
	infinite: true,
  autoplay: true,
  adaptiveHeight: true
});
